import React from 'react';
import { SvgIcon } from '@mui/material';

function VeganIcon({ color = '#757575', ...props }) {
  return (
    <SvgIcon viewBox="0 0 64 64" sx={{ width: 20, height: 20 }} {...props}>
      <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect opacity="0.15" x="2.74756" y="2" width="20" height="20" rx="4" fill={color} />
        <path d="M11.365 16.9035L8.36841 7.09644H10.2753L12.7271 15.16L15.2197 7.09644H17.1267L14.1301 16.9035H11.365Z" fill={color} />
      </svg>
    </SvgIcon>
  );
}
export default VeganIcon;
